// OEM App 定制 — 项目已创建的「应用组」mock（企业端 / 管理端共用）
// 语义：应用组 = App管理里的一个「应用」；versions = 系统平台-上架区域 + AppID
// 应用被删除后由后端返回最新列表，此处移除即可恢复「创建应用」
// TODO: 联调时替换为接口数据

export const INITIAL_PROJECT_APPS = {
    // 单个 App、单个版本 → 列表直接展示「App名称 + AppID」
    'OEM-1007': [
        { id: 'APP-7001', name: '全场景智能', versions: [{ platformLabel: 'Android', regionLabel: '国内', appId: 'com.hm.qcj' }] },
    ],
    // 多个 App → 列表展示数量，点击弹窗看树形结构
    'OEM-1008': [
        {
            id: 'APP-8001',
            name: '云视通',
            versions: [
                { platformLabel: 'Android', regionLabel: '国内', appId: 'com.hm.yst' },
                { platformLabel: 'iOS', regionLabel: '全球通用', appId: 'com.hm.yst.ios' },
            ],
        },
        { id: 'APP-8002', name: '云视通海外版', versions: [{ platformLabel: 'Android', regionLabel: '海外', appId: 'com.hm.yst.os' }] },
    ],
};

export const appsOfProject = (id) => INITIAL_PROJECT_APPS[id] || [];

export const hasProjectApp = (id) => appsOfProject(id).length > 0;
